import { render, staticRenderFns } from "./SettingCreation.vue?vue&type=template&id=952f0db8&"
import script from "./SettingCreation.vue?vue&type=script&lang=js&"
export * from "./SettingCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports